// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
---------------
CSS Reset https://www.joshwcomeau.com/css/custom-css-reset/
---------------
*/

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
* {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

/* I added the 3 below */

ul {
  padding-inline-start: 0;
}

li {
  list-style-type: none;
}

a {
  text-decoration: none;
  display: inline-block;
}

/*
---------------
Font size variables
---------------
*/

/* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */
:root {
  /* Step -2: 11.1111px → 12.8px */
  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);
  /* Step -1: 13.3333px → 16px */
  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);
  /* Step 0: 16px → 20px */
  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);
  /* Step 1: 19.2px → 25px */
  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);
  /* Step 2: 23.04px → 31.25px */
  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);
  /* Step 3: 27.648px → 39.0625px */
  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);
  /* Step 4: 33.1776px → 48.8281px */
  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);
  /* Step 5: 39.8131px → 61.0352px */
  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);
}

/*
---------------
Space variables
---------------
*/

/* https://utopia.fyi/space/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75%7C0.5%7C0.25,1.5%7C2%7C3%7C4%7C6,s-l&g=s,l,xl,12 */
:root {
  /* Space 3xs: 4px → 5px */
  --space-3xs: clamp(0.25rem, 0.2358rem + 0.071vw, 0.3125rem);
  /* Space 2xs: 8px → 10px */
  --space-2xs: clamp(0.5rem, 0.4716rem + 0.142vw, 0.625rem);
  /* Space xs: 12px → 15px */
  --space-xs: clamp(0.75rem, 0.7074rem + 0.2131vw, 0.9375rem);
  /* Space s: 16px → 20px */
  --space-s: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);
  /* Space m: 24px → 30px */
  --space-m: clamp(1.5rem, 1.4148rem + 0.4261vw, 1.875rem);
  /* Space l: 32px → 40px */
  --space-l: clamp(2rem, 1.8864rem + 0.5682vw, 2.5rem);
  /* Space xl: 48px → 60px */
  --space-xl: clamp(3rem, 2.8295rem + 0.8523vw, 3.75rem);
  /* Space 2xl: 64px → 80px */
  --space-2xl: clamp(4rem, 3.7727rem + 1.1364vw, 5rem);
  /* Space 3xl: 96px → 120px */
  --space-3xl: clamp(6rem, 5.6591rem + 1.7045vw, 7.5rem);
}

/*
---------------
Font
---------------
*/

body {
  font-family: 'Roboto', sans-serif;
  font-size: var(--step-0);
}

h4 {
  font-size: var(--step-1);
}

h3 {
  font-size: var(--step-3);
}

h2 {
  font-family: 'Anta', sans-serif;
  font-size: var(--step-4);
}

header h1 {
  font-family: 'Anta', sans-serif;
  font-size: var(--step-2);
}

/*
---------------
Layout
---------------
*/

body {
  min-height: 100vh;
  color: #1a1a1a;
  background-color: #f4f1ec;
}

.weather-icon,
.alert-icon,
.logo {
  width: 50px;
}

header,
.todays-weather,
.hourly-forecast,
.ten-day-forecast {
  max-width: 1200px;
  padding: var(--space-s);
  margin: 0 auto;
}

/* Everything within header below */

header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: #e6e0d6 solid 2px;
}

.logo-and-name-container,
.form-and-buttons-container {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);
}

.current-location-button,
.convert-degrees-button {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 5px;
  border: none;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  color: #f4f1ec;
  background-color: #e68264;
}

.convert-degrees-button {
  font-weight: 500;
}

.search-location-form {
  height: 40px;

  display: flex;
  align-items: center;

  background-color: #e6e0d6;
  border-radius: 5px;
}

#search-location {
  all: unset;
  padding: 0.5rem;
}

#search-location::placeholder,
.search-icon {
  color: rgba(0, 0, 0, 0.3);
}

.search-location-button {
  display: flex;
  align-items: center;

  background-color: transparent;
  border: none;
}

@media screen and (max-width: 650px) {
  header {
    flex-direction: column;
    gap: 1rem;
  }
}

/* Everything within Today's Weather below */

.todays-weather {
  margin: var(--space-xl) auto;
  text-align: center;
}

.alerts-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);
  padding: var(--space-s);
  margin-top: var(--space-s);

  background-color: #ffde50;
  border-radius: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.todays-weather-info {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: var(--space-s);
  padding: var(--space-m);
  margin-top: var(--space-m);

  background-color: #84abc1;
  border-radius: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.summary-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);
  padding: var(--space-s);
}

.todays-icon-and-temp-container {
  display: flex;
  align-items: center;
  justify-self: center;
  gap: var(--space-xs);

  font-size: var(--step-1);
  font-weight: 700;
}

.todays-description {
  max-width: 40ch;
}

.conditions-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: var(--space-m);
}

.condition-card {
  padding: var(--space-xs);

  background-color: #f4f1ec;
  border-radius: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.condition-card > :first-child {
  border-bottom: #84abc1 solid 2px;
  margin-bottom: var(--space-2xs);
}

@media screen and (max-width: 800px) {
  .todays-weather-info {
    flex-direction: column;
  }
}

/* Everything within Hourly Forecast below */

.hourly-forecast {
  margin: var(--space-xl) auto;
}

.hourly-forecast h2 {
  text-align: center;
  margin-bottom: var(--space-s);
}

.hourly-forecast-card {
  min-width: max-content;
  padding: var(--space-xs) var(--space-m);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);

  border-right: 2px solid #84abc1;
}

.hourly-forecast-card:last-of-type {
  border-right: none;
}

.scroll-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* same div as .hourly-forecast-content */
.scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  /* Hide scrollbar */
  scrollbar-width: none;
}

.left-arrow-button,
.right-arrow-button {
  font-size: var(--step-5);
  color: #e68264;
  background: transparent;
  border: none;
}

/* Everything within 10 day Forecast below */

.ten-day-forecast {
  margin: var(--space-xl) auto;
}

.ten-day-forecast h2 {
  text-align: center;
  margin-bottom: var(--space-m);
}

.day-container {
  margin: var(--space-s) 0;
  padding: var(--space-xs);

  display: grid;
  grid-template-columns: 1fr 1fr 2fr 1fr;
  gap: var(--space-xs);
  align-items: center;

  border-radius: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  background-color: #e6e0d6;
}

.day-of-the-week-and-date-container {
  justify-self: start;
  text-align: center;
}

.low-high-temps {
  justify-self: end;
  text-align: center;

  display: flex;
  gap: var(--space-2xs);
}

.low-high-temps > :first-child {
  border-right: 2px solid #84abc1;
  padding-right: var(--space-2xs);
}

@media screen and (max-width: 620px) {
  .day-and-date-container {
    justify-self: center;
  }

  .low-high-temps {
    flex-direction: column;
    width: 100%;
  }

  .low-high-temps > :first-child {
    border-right: none;
    padding-right: 0;

    border-bottom: 2px solid #84abc1;
    padding-bottom: var(--space-2xs);
  }
}

/* Footer */

footer {
  padding: var(--space-s);
  text-align: center;
  background-color: #84abc1;
}

footer a {
  color: #f4f1ec;
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;CAIC;;AAED,wHAAwH;AACxH;EACE,gCAAgC;EAChC,yDAAyD;EACzD,8BAA8B;EAC9B,uDAAuD;EACvD,wBAAwB;EACxB,oDAAoD;EACpD,0BAA0B;EAC1B,wDAAwD;EACxD,8BAA8B;EAC9B,yDAAyD;EACzD,iCAAiC;EACjC,0DAA0D;EAC1D,kCAAkC;EAClC,2DAA2D;EAC3D,kCAAkC;EAClC,2DAA2D;AAC7D;;AAEA;;;;CAIC;;AAED,+HAA+H;AAC/H;EACE,yBAAyB;EACzB,2DAA2D;EAC3D,0BAA0B;EAC1B,yDAAyD;EACzD,0BAA0B;EAC1B,2DAA2D;EAC3D,yBAAyB;EACzB,qDAAqD;EACrD,yBAAyB;EACzB,wDAAwD;EACxD,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;EAC1B,sDAAsD;EACtD,2BAA2B;EAC3B,oDAAoD;EACpD,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;;;;CAIC;;AAED;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;;;;CAIC;;AAED;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;;EAEZ,aAAa;EACb,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,4CAA4C;;AAE5C;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;;EAE1B,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;;EAE1B,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;;EAEpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;;EAExB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,4CAA4C;;AAE5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;;EAEvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;;EAEpB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA,4CAA4C;;AAE5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;;EAExB,aAAa;EACb,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;;EAEnB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;;IAEhB,gCAAgC;IAChC,gCAAgC;EAClC;AACF;;AAEA,WAAW;;AAEX;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/*\n---------------\nCSS Reset https://www.joshwcomeau.com/css/custom-css-reset/\n---------------\n*/\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n* {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* I added the 3 below */\n\nul {\n  padding-inline-start: 0;\n}\n\nli {\n  list-style-type: none;\n}\n\na {\n  text-decoration: none;\n  display: inline-block;\n}\n\n/*\n---------------\nFont size variables\n---------------\n*/\n\n/* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */\n:root {\n  /* Step -2: 11.1111px → 12.8px */\n  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);\n  /* Step -1: 13.3333px → 16px */\n  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);\n  /* Step 0: 16px → 20px */\n  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);\n  /* Step 1: 19.2px → 25px */\n  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);\n  /* Step 2: 23.04px → 31.25px */\n  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);\n  /* Step 3: 27.648px → 39.0625px */\n  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);\n  /* Step 4: 33.1776px → 48.8281px */\n  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);\n  /* Step 5: 39.8131px → 61.0352px */\n  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);\n}\n\n/*\n---------------\nSpace variables\n---------------\n*/\n\n/* https://utopia.fyi/space/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75%7C0.5%7C0.25,1.5%7C2%7C3%7C4%7C6,s-l&g=s,l,xl,12 */\n:root {\n  /* Space 3xs: 4px → 5px */\n  --space-3xs: clamp(0.25rem, 0.2358rem + 0.071vw, 0.3125rem);\n  /* Space 2xs: 8px → 10px */\n  --space-2xs: clamp(0.5rem, 0.4716rem + 0.142vw, 0.625rem);\n  /* Space xs: 12px → 15px */\n  --space-xs: clamp(0.75rem, 0.7074rem + 0.2131vw, 0.9375rem);\n  /* Space s: 16px → 20px */\n  --space-s: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);\n  /* Space m: 24px → 30px */\n  --space-m: clamp(1.5rem, 1.4148rem + 0.4261vw, 1.875rem);\n  /* Space l: 32px → 40px */\n  --space-l: clamp(2rem, 1.8864rem + 0.5682vw, 2.5rem);\n  /* Space xl: 48px → 60px */\n  --space-xl: clamp(3rem, 2.8295rem + 0.8523vw, 3.75rem);\n  /* Space 2xl: 64px → 80px */\n  --space-2xl: clamp(4rem, 3.7727rem + 1.1364vw, 5rem);\n  /* Space 3xl: 96px → 120px */\n  --space-3xl: clamp(6rem, 5.6591rem + 1.7045vw, 7.5rem);\n}\n\n/*\n---------------\nFont\n---------------\n*/\n\nbody {\n  font-family: 'Roboto', sans-serif;\n  font-size: var(--step-0);\n}\n\nh4 {\n  font-size: var(--step-1);\n}\n\nh3 {\n  font-size: var(--step-3);\n}\n\nh2 {\n  font-family: 'Anta', sans-serif;\n  font-size: var(--step-4);\n}\n\nheader h1 {\n  font-family: 'Anta', sans-serif;\n  font-size: var(--step-2);\n}\n\n/*\n---------------\nLayout\n---------------\n*/\n\nbody {\n  min-height: 100vh;\n  color: #1a1a1a;\n  background-color: #f4f1ec;\n}\n\n.weather-icon,\n.alert-icon,\n.logo {\n  width: 50px;\n}\n\nheader,\n.todays-weather,\n.hourly-forecast,\n.ten-day-forecast {\n  max-width: 1200px;\n  padding: var(--space-s);\n  margin: 0 auto;\n}\n\n/* Everything within header below */\n\nheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  border-bottom: #e6e0d6 solid 2px;\n}\n\n.logo-and-name-container,\n.form-and-buttons-container {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2xs);\n}\n\n.current-location-button,\n.convert-degrees-button {\n  width: 40px;\n  height: 40px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 5px;\n  border: none;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n  color: #f4f1ec;\n  background-color: #e68264;\n}\n\n.convert-degrees-button {\n  font-weight: 500;\n}\n\n.search-location-form {\n  height: 40px;\n\n  display: flex;\n  align-items: center;\n\n  background-color: #e6e0d6;\n  border-radius: 5px;\n}\n\n#search-location {\n  all: unset;\n  padding: 0.5rem;\n}\n\n#search-location::placeholder,\n.search-icon {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.search-location-button {\n  display: flex;\n  align-items: center;\n\n  background-color: transparent;\n  border: none;\n}\n\n@media screen and (max-width: 650px) {\n  header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n/* Everything within Today's Weather below */\n\n.todays-weather {\n  margin: var(--space-xl) auto;\n  text-align: center;\n}\n\n.alerts-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-s);\n  padding: var(--space-s);\n  margin-top: var(--space-s);\n\n  background-color: #ffde50;\n  border-radius: 15px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n}\n\n.todays-weather-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  gap: var(--space-s);\n  padding: var(--space-m);\n  margin-top: var(--space-m);\n\n  background-color: #84abc1;\n  border-radius: 15px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n}\n\n.summary-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-s);\n  padding: var(--space-s);\n}\n\n.todays-icon-and-temp-container {\n  display: flex;\n  align-items: center;\n  justify-self: center;\n  gap: var(--space-xs);\n\n  font-size: var(--step-1);\n  font-weight: 700;\n}\n\n.todays-description {\n  max-width: 40ch;\n}\n\n.conditions-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n  gap: var(--space-m);\n}\n\n.condition-card {\n  padding: var(--space-xs);\n\n  background-color: #f4f1ec;\n  border-radius: 15px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n}\n\n.condition-card > :first-child {\n  border-bottom: #84abc1 solid 2px;\n  margin-bottom: var(--space-2xs);\n}\n\n@media screen and (max-width: 800px) {\n  .todays-weather-info {\n    flex-direction: column;\n  }\n}\n\n/* Everything within Hourly Forecast below */\n\n.hourly-forecast {\n  margin: var(--space-xl) auto;\n}\n\n.hourly-forecast h2 {\n  text-align: center;\n  margin-bottom: var(--space-s);\n}\n\n.hourly-forecast-card {\n  min-width: max-content;\n  padding: var(--space-xs) var(--space-m);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n\n  border-right: 2px solid #84abc1;\n}\n\n.hourly-forecast-card:last-of-type {\n  border-right: none;\n}\n\n.scroll-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* same div as .hourly-forecast-content */\n.scroll-container {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  /* Hide scrollbar */\n  scrollbar-width: none;\n}\n\n.left-arrow-button,\n.right-arrow-button {\n  font-size: var(--step-5);\n  color: #e68264;\n  background: transparent;\n  border: none;\n}\n\n/* Everything within 10 day Forecast below */\n\n.ten-day-forecast {\n  margin: var(--space-xl) auto;\n}\n\n.ten-day-forecast h2 {\n  text-align: center;\n  margin-bottom: var(--space-m);\n}\n\n.day-container {\n  margin: var(--space-s) 0;\n  padding: var(--space-xs);\n\n  display: grid;\n  grid-template-columns: 1fr 1fr 2fr 1fr;\n  gap: var(--space-xs);\n  align-items: center;\n\n  border-radius: 15px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n  background-color: #e6e0d6;\n}\n\n.day-of-the-week-and-date-container {\n  justify-self: start;\n  text-align: center;\n}\n\n.low-high-temps {\n  justify-self: end;\n  text-align: center;\n\n  display: flex;\n  gap: var(--space-2xs);\n}\n\n.low-high-temps > :first-child {\n  border-right: 2px solid #84abc1;\n  padding-right: var(--space-2xs);\n}\n\n@media screen and (max-width: 620px) {\n  .day-and-date-container {\n    justify-self: center;\n  }\n\n  .low-high-temps {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .low-high-temps > :first-child {\n    border-right: none;\n    padding-right: 0;\n\n    border-bottom: 2px solid #84abc1;\n    padding-bottom: var(--space-2xs);\n  }\n}\n\n/* Footer */\n\nfooter {\n  padding: var(--space-s);\n  text-align: center;\n  background-color: #84abc1;\n}\n\nfooter a {\n  color: #f4f1ec;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
